export const featureFlags = {
    // The Encaissées tab. Sidelined together with the backend paid transition
    // (RelancePaidFeature), which is what populates it — so turning this on alone surfaces a
    // permanently empty tab. Re-enabling the feature means flipping both, plus a data migration.
    // The Encaisser action button is deliberately NOT gated by this; see useCanCollectPayment.
    paidRelancesTab: false as boolean,
    // Onboarding screen 3 (Loi 25 consent) — hidden pending legal/compliance validation of its text
    // (ADO Task 295300). __mocks__/featureFlags.ts keeps this true so Jest still exercises the full
    // consent flow; only the real build hides it.
    onboardingConsentScreen: false as boolean,
    // The AI-generated title under « Synthèse du dossier » on the relance page — hidden because it
    // mostly repeated the reasoning. Off, the page neither shows nor requests it.
    aiRecapTitle: false as boolean,
} as const;
